<!--
 * @Description: 新客评审 - 添加页面
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <DetailForm ref="detailFormRef" type="add" isEdit v-model:value="dataForm" :resetValue="initForm" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { onBeforeMount, reactive, ref } from 'vue'
import { cloneDeep } from 'lodash-es'
import DetailForm from './components/DetailForm.vue'
import type { FbuSalesClueEditParams } from '@/typings/api/clueManage'
import { salesClueDetail } from '@/api/overseasSales/clueManage'
import { useRoute } from 'vue-router'
const route = useRoute()

const initForm = reactive<FbuSalesClueEditParams.RootObject>({
  contact: {},
  business: {
    demandInfo: { warehouses: [{}] },
    saleInfo: [{}],
    quotationInfo: { details: [{}] },
    contractInfo: { fixedCredit: {}, registrationFee: {}, monthlyMaintenanceFee: {} }
  },
  visitAddress: [{}]
})

const dataForm = reactive<FbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

onBeforeMount(() => {
  salesClueDetail({ clueId: route.query.clueId as string }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    if (res.data.clueId) {
      res.data.cosId = res.data.clueId
      res.data.clueId = undefined
    }
    if (res.data.follower) {
      res.data.seller = res.data.follower
    }
    if (res.data.contact) {
      res.data.contact = undefined
    }
    if (res.data.visitAddress) {
      res.data.visitAddress = undefined
    }
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})
</script>
<script lang="ts">
export default { name: 'DcCosOFbuNewClientEvaluationAdd' }
</script>

<style lang="scss" scoped></style>
